import clsx from "clsx";

import { AndroidImg, AppleImg, GooglePlayImg, UrlImg } from "@/assets/app";
import {
  APK_URL,
  APP_STORE_URL,
  GOOGLE_PLAY_URL,
  URL_BUTTON_LINK,
} from "@/data/links";

interface StoreButtonProps {
  href: string;
  icon: string;
  iconClassName?: string;
  topText: string;
  bottomText: string;
}

// Greyed-out treatment for buttons whose download target does not exist yet:
// grayscale kills the colored store logos, opacity mutes the frame and label.
const DISABLED_STYLE = "opacity-40 grayscale cursor-not-allowed select-none";

// 170x68 outlined store button per the v2 design.
function StoreButton({
  href,
  icon,
  iconClassName,
  topText,
  bottomText,
}: StoreButtonProps) {
  const Tag = href ? "a" : "div";
  return (
    <Tag
      {...(href
        ? { href, target: "_blank", rel: "noopener noreferrer" }
        : { "aria-disabled": true })}
      className={clsx(
        "flex items-center gap-[8px]",
        "w-[170px] h-[68px] px-[14px]",
        "border border-white rounded-[12px]",
        href
          ? "hover:opacity-85 active:opacity-75 transition-opacity"
          : DISABLED_STYLE,
      )}
    >
      <img
        src={icon}
        alt=""
        className={clsx("w-[32px] shrink-0", iconClassName)}
      />
      <div className="flex flex-col gap-[2px] items-start text-white whitespace-nowrap">
        <span className="text-[12px] leading-[16px]">{topText}</span>
        <span className="text-[18px] leading-[26px] font-bold whitespace-pre">
          {bottomText}
        </span>
      </div>
    </Tag>
  );
}

// The Android / Google Play / APP Store / URL button row used in the footer
// and both "Start Trading" sections.
export default function StoreButtons() {
  const UrlTag = URL_BUTTON_LINK ? "a" : "div";
  return (
    <div className="flex gap-[20px] items-start">
      <StoreButton
        href={APK_URL}
        icon={AndroidImg}
        topText="Download APK"
        bottomText="Android"
      />
      <StoreButton
        href={GOOGLE_PLAY_URL}
        icon={GooglePlayImg}
        iconClassName="h-[32px] object-contain"
        topText="Get oh"
        bottomText={"Google  Play"}
      />
      <StoreButton
        href={APP_STORE_URL}
        icon={AppleImg}
        topText="Download on the"
        bottomText={"APP  Store"}
      />
      <UrlTag
        {...(URL_BUTTON_LINK
          ? {
              href: URL_BUTTON_LINK,
              target: "_blank",
              rel: "noopener noreferrer",
            }
          : { "aria-disabled": true })}
        className={clsx(
          "flex flex-col items-center justify-center",
          "size-[68px] rounded-[12px]",
          "bg-white/15 border border-white/50",
          URL_BUTTON_LINK
            ? "hover:opacity-85 active:opacity-75 transition-opacity"
            : DISABLED_STYLE,
        )}
      >
        <img src={UrlImg} alt="" className="size-[32px]" />
        <span className="text-[18px] leading-[26px] font-bold text-white -mt-[4px]">
          URL
        </span>
      </UrlTag>
    </div>
  );
}
